// I18n-js package is over-bloated
import {I18n} from '@js/modules/i18n/I18n';

// The dictionary now arrives as a cacheable <script src> that sets window.__translations.
// The inline <script type="application/json"> is the fallback for a page rendered before the
// packaging task ran; both are loaded before the bundle, so this stays synchronous.
let localeTranslations = [];
if (window.__translations) {
    localeTranslations = window.__translations;
} else {
    const localeTranslationsElement = document.getElementById('translations');
    if (localeTranslationsElement && !!localeTranslationsElement.innerText) {
        localeTranslations = JSON.parse(localeTranslationsElement.innerText);
    }
}

const i18n = new I18n(localeTranslations);

i18n.defaultLocale = window.defaultLocale;
i18n.locale = window.locale;
i18n.availableLocales = window.locales;

export default i18n;
